import {
  Children,
  PropsWithChildren,
  cloneElement,
  isValidElement,
} from 'react';

import { Accordion } from 'components/Accordion/Accordion';
import { TextBadge } from 'components/Badge/TextBadge';
import { DropdownChevron } from 'components/Dropdown/Chevron/DropdownChevron';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownMenu } from 'components/Dropdown/menus/Menu/DropdownMenu';
import { Icon } from 'components/Icon/Icon';
import { Pill } from 'components/Pill/Pill';
import { ScrollArea } from 'components/ScrollArea/ScrollArea';
import { SearchFacetDropdownHolder } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown.styled';
import { useSearchRefinementsOverflow } from 'modules/search/hooks/refinements/useSearchRefinementsOverflow';
import { SearchFacetVariant } from 'modules/search/types/SearchFacetVariant';
import { spacing } from 'theme/theme';

export function SearchRefinementsOverflowDropdown({
  children,
}: PropsWithChildren) {
  const { overflowRefinementsRef, selectedRefinementValues } =
    useSearchRefinementsOverflow();

  return (
    <SearchFacetDropdownHolder ref={overflowRefinementsRef}>
      <Dropdown
        trigger={
          <Pill
            size="medium"
            prefix={<Icon size={18} name="plus" />}
            suffix={<DropdownChevron size={16} />}
          >
            {getText('More Filters')}{' '}
            <TextBadge content={selectedRefinementValues} />
          </Pill>
        }
      >
        <DropdownMenu
          offsetY={spacing[8]}
          placement="bottom-left"
          width="350px"
        >
          <Accordion>
            <ScrollArea
              height="calc(100vh - 211px)"
              direction="vertical"
              hideScrollBar
            >
              {Children.map(children, (child) => {
                if (
                  !isValidElement<{
                    variant: SearchFacetVariant;
                  }>(child)
                ) {
                  return child;
                }

                return cloneElement(child, {
                  variant: 'accordion',
                });
              })}
            </ScrollArea>
          </Accordion>
        </DropdownMenu>
      </Dropdown>
    </SearchFacetDropdownHolder>
  );
}
